// Edit Item modal: hosts the SAME single-screen item form the manage-items
// board uses, in edit mode — every field (product, flexibility, demand,
// notes) prefilled from the item, PATCHing only what changed. Single-item
// editing and board editing share one implementation by design; unlike the
// retired bespoke form, the linked product itself is editable here too.

import { RestaurantInquiryItem, useGetRestaurantInquiryApi } from 'apis/restaurant-inquiries';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from 'design-system';
import { ItemWizard } from 'pages/inquiry-processor/components/item-board';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  inquiryId: string;
  item: RestaurantInquiryItem;
}

export const EditItemModal = ({ isOpen, onClose, inquiryId, item }: Props) => {
  // Same query key the opening screen already holds — served from cache, no
  // extra fetch. Needed for the wizard's already-added-variant exclusion;
  // while absent the wizard just doesn't filter.
  const { data: inquiry } = useGetRestaurantInquiryApi(inquiryId);
  const others = (inquiry?.items ?? []).filter((i) => i.id !== item.id);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: '6xl' }} scrollBehavior='inside'>
      <ModalOverlay />
      <ModalContent maxW={{ base: '100vw', md: 'min(1400px, 96vw)' }}>
        <ModalHeader>Edit Item</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb='5'>
          <ItemWizard
            embedded
            inquiryId={inquiryId}
            item={item}
            excludeIds={others.map((i) => i.masterProductId)}
            onClose={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
